import { Controller } from "stimulus";

export default class extends Controller {
  // Component Init
  connect = () => {
    // Check if it should start sticky.
    this.checkSticky();

    // Check again after page is fully loaded, resized, or scrolled.
    window.addEventListener("load", this.checkSticky, true);
    window.addEventListener("resize", this.checkSticky, true);
    window.addEventListener("scroll", this.checkSticky, true);

    // Use Array.from() to make an iterable from querySelectorAll() results.
    this.listItems = Array.from(this.element.querySelectorAll(".menu > li"));

    // Add event listeners to all the list items.
    this.listItems.map(li => {
      li.addEventListener("click", this.handleLiClick);
      li.addEventListener("mouseenter", this.handleLiHover);
      li.addEventListener("mouseleave", this.handleLiHoverOut);
    });
  };

  // Get the distances of the menu from the top of the document.
  getOffsetTop = () =>
    this.element.parentElement.getBoundingClientRect().top +
    document.documentElement.scrollTop;

  // Sticky the menu if it needs.
  checkSticky = () => {
    // Get the header height, height from the doc top, and scrolled height.
    let headerHeight = document.querySelector("body > .header").offsetHeight;
    let offsetTop = this.getOffsetTop();
    let scrollPos = Math.round(window.scrollY);

    // If scrolled to where the menu hits the header..
    if (scrollPos >= offsetTop - headerHeight) {
      // Sticky it.
      this.element.style.position = `fixed`;
      this.element.style.top = `${headerHeight}px`;
    } else {
      // ..otherwise, let it use the natural flow.
      this.element.style.position = `relative`;
      this.element.style.top = `0`;
    }
  };

  // Click Event Handler for List Items (toggle dropdown if it exists).
  handleLiClick = e => {
    this.listItems.map(li => {
      li == e.currentTarget
        ? li.classList.toggle("open")
        : li.classList.remove("open");
    });
  };

  // Hover Event Handler for List Items.
  handleLiHover = e => {
    this.listItems.map(li => (li.style.opacity = `0.25`));
    e.target.style.opacity = `1`;
  };

  // Un-hover Event Handler for List Items.
  handleLiHoverOut = e => {
    this.listItems.map(li => (li.style.opacity = `1`));
  };
}
